<template>
  <div class="sidebar-footer text-center">
    <v-divider class="sidebar-footer-divider"></v-divider>
    <div class="py-3">
      <a
        v-for="icon in icons" :key="icon.link"
        class="footer-icon-link mx-2"
        target="_blank" rel="noopener noreferrer"
        :href="icon.link"
      >
        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <span class="icon-badge" v-bind="attrs" v-on="on">
                    <v-icon size="18px">{{ icon.icon }}</v-icon>
                </span>
            </template>
            {{ icon.tooltip }}
        </v-tooltip>
      </a>
      <div class="footer-text mt-2">
        &copy; 2019 - {{ new Date().getFullYear() }}<br>MYSCH.NG | v5.2.2
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SidebarFooter',
    data: () => ({
        icons: [
            {icon:'mdi-message-text', link: 'https://tawk.to/chat/67327c9b2480f5b4f59be4d2/1icejdgfb', tooltip: 'Start a Live Chat'},
            {icon:'mdi-whatsapp', link: 'https://wa.me/2347081307643', tooltip: 'Chat on WhatsApp'},
            {icon:'mdi-video-vintage', link: 'https://www.youtube.com/watch?v=PjH4QiOVwPM', tooltip: 'Watch how to use'},
        ],
    }),
}
</script>

<style scoped>
.sidebar-footer-divider{
    border-color: rgba(255, 255, 255, 0.1) !important;
}
.footer-icon-link{
    text-decoration: none;
    display: inline-flex;
}
.icon-badge{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.85);
    transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}
.footer-icon-link:hover .icon-badge{
    background: rgba(251, 140, 0, 0.22);
    color: #FB8C00;
    transform: translateY(-2px);
}
.footer-text{
    color: rgba(255, 255, 255, 0.55);
    font-size: 0.7rem;
    line-height: 1.5;
}
</style>
